import { Link } from "react-router-dom";
import "layout/Footer/Copyright/Copyright.scss";

function Footer() {
  return (
      <div className="copyright">
        <div className="wrapper--fluid">
          <ul>
            <li><Link to="/privacyverklaring">Privacyverklaring</Link></li>
            <li><Link to="/disclaimer">Disclaimer</Link></li>
            <li><Link to="/cookies">Cookies</Link></li>
          </ul>
        </div>
      </div>
  )
}

export default Footer;
